import { ArrowLeftIcon } from "@phosphor-icons/react";
import { DropZone } from "components/DropZone/DropZone/";
import { useTranslate } from "@refinedev/core";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { HeyGeniusButton } from "../../components/HeyGeniusButton";
import { useFeature } from "hooks/useFeature/";
import { FeatureFlags } from "constants/";
import {
  CenterContent,
  HeaderGroup,
  Headline,
  PageWrapper,
  Subtext,
  BackLink,
} from "./styles";
import { EncryptedNote } from "./EncryptedNote";

interface ProjectInitProps {
  showHeyGeniusButton?: boolean;
}

export const ProjectInit = ({ showHeyGeniusButton }: ProjectInitProps) => {
  const [fileDropped, setFileDropped] = useState(false);
  const t = useTranslate();
  const navigate = useNavigate();
  const { isEnabled: isHeyGeniusEnable } = useFeature(
    FeatureFlags.HeyGeniusProject
  );
  const canCreateHeyGenius = showHeyGeniusButton && isHeyGeniusEnable;

  return (
    <PageWrapper>
      <CenterContent>
        <BackLink
          type="button"
          onClick={() => navigate("/media/projects/create")}
        >
          <ArrowLeftIcon size={16} />
          {t("pages.home.index.back", "Back")}
        </BackLink>

        <HeaderGroup $hidden={fileDropped}>
          <Subtext>{t("pages.home.index.dropFileTag")}</Subtext>
          <Headline>{t("pages.home.index.dropFileHeadline")}</Headline>
        </HeaderGroup>

        <DropZone onUploadStart={() => setFileDropped(true)} />
        {canCreateHeyGenius && <HeyGeniusButton />}

        <EncryptedNote />
      </CenterContent>
    </PageWrapper>
  );
};
